export default {"src":"/_next/static/media/share.7515e47e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};